<template>
  <div class="container">
    <div v-for="(contact, k) in contacts" :key="k">
      <h5>{{ pax['covid19_portal'][1].CONTACT }} {{ k + 1 }} <i v-if="contact.id" class="fa fa-check" aria-hidden="true"></i></h5>
      <div class="row control-group">
        <div class="col-10" @click="focusInput(k)">
          <VueTelInput
            v-model="contact.phone_number"
            :input-id="'phone_number' + k"
            required
            :disabled="contact.id ? true : false"
            @input="onInput"
          ></VueTelInput>
        </div>
        <div class="col-2 text-center"><i class="fas fa-trash-alt cursor" @click="$emit('removeContact', k)"></i></div>
      </div>
    </div>
    <div class="add-new">
      <i class="fas fa-plus-circle cursor" @click="$emit('addContact')"></i>
    </div>
    <div>
      <button type="button" class="btnShare cursor" @click="$emit('shareUpdate')">{{ pax.covid19_portal['1'].SHARE }}</button>
    </div>
  </div>
</template>
<script>
import 'vue-tel-input/dist/vue-tel-input.css'
import VueTelInput from 'vue-tel-input'

export default {
  components: { VueTelInput },
  props: {
    contacts: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      focusInputId: -1
    }
  },
  methods: {
    onInput: function (formattedNumber, { number, isValid, country }) {
      if (this.focusInputId > -1) {
        this.$emit('onInput', number, isValid, country, this.focusInputId)
      }
    },
    focusInput: function (k) {
      this.focusInputId = k
    }
  }
}
</script>
